<template lang="pug">
.container(id="DeleteExtensionsForm-container")
  h4 {{$t('Used Extensions')}}
  hr.header
  p.error(v-if='loading')
    span {{ $t('loading...') }}.
  .existing-extension-section(v-if='exisitingUsedExtensions.length > 0')
    p.advice(id="DeleteExtensionsForm-unusedExtensionsInfo")
      span {{ $t('Used extensions.')}}
  .existing-extension-section(v-if='exisitingUsedExtensions.length > 0')
    .existing-extension-row
      .cell.header.name {{ $t('Name')}}
      .cell.header.version {{ $t('Version')}}
      .cell.header.description {{ $t('Description')}}
      .cell.header.global {{ $t('Playlist')}}
      .cell.header.global {{ $t('Global/Local')}}
      .cell.header.global {{ $t('Network')}}
      .cell.header.global {{ $t('Edit')}}
  .existing-extension-section(v-if='exisitingUsedExtensions.length > 0')
    .existing-extension-row(
      v-for='exisitingExtension of exisitingUsedExtensions',
      :key='exisitingExtension.id',
      :id="'DeleteExtensionsForm-extensionRow' + exisitingExtension.id"
    )
      .cell.name {{ exisitingExtension.name }}
        //- pre {{ exisitingExtension }}
      .cell.version {{ exisitingExtension.version }}
      .cell.description {{ exisitingExtension.description }}
      .cell.global
        span(v-if="exisitingExtension.isPlayListExtension")
          font-awesome-icon(:title='$t("Playlist")', icon="film")
        span(v-if="!exisitingExtension.isPlayListExtension")
          font-awesome-icon(:title='$t("HTML5")', icon="code")
      .cell.global
        span(v-if="exisitingExtension.networkName")
          font-awesome-icon(:title='$t("Local")', icon="wifi")
        span(v-if="!exisitingExtension.networkName")
          font-awesome-icon(:title='$t("Global")', icon="globe")
      .cell.global
          p.cursor(v-for='usage of exisitingExtension.usage', @click='handleSelectNetwork(usage)', type="text", size="mini")
            span.cursor-pointer {{ usage.name }}
      .cell.global
          el-button(type="success", size="mini", @click='editExtension(exisitingExtension)')
            font-awesome-icon.float-right(:title='$t("Edit")', icon="edit")
  el-dialog(:visible.sync='editExtensionVisible', @close='closeEditExtension()', append-to-body)
    .form-container
      el-form(v-if='editedExtension', size="mini", label-width="120px")
        el-form-item(:label='$t("Name")')
          el-input(id="EditExtension-nameInput" v-model='editedExtension.name', :placeholder='$t("Name (at least 3 characters)")', style="width: 450px;")
        el-form-item(:label='$t("Description")')
          el-input(id="EditExtension-descriptionInput" v-model='editedExtension.description', :placeholder='$t("Description")', style="width: 450px;")
        el-form-item(:label="$t('Version')")
          el-input.el-input(id="EditExtension-formVersionInput" v-model='editedExtension.version', type="text", name="version", ref="version", style="width: 450px;", :placeholder="$t('version')")
        el-form-item(:label="$t('Playlist')")
          el-switch(id="EditExtension-formIsPlaylistSwitch" v-model='editedExtension.isPlayListExtension', :active-text='$t("yes")', :inactive-text='$t("no")')
        el-form-item(:label="$t('Local/Global')", v-if='!isGlobal')
          el-switch(id="EditExtension-formIsGlobalSwitch" v-model='isGlobal', :active-text='$t("global")', :inactive-text='$t("local")')
        el-form-item(:label="$t('Local/Global')", v-if='isGlobal && editedExtension.usage.length === 1')
          el-switch(id="EditExtension-formIsGlobalSwitch" v-model='isGlobal', :active-text='$t("global")', :inactive-text='$t("local")')
        el-form-item(:label="$t('Local/Global')", v-if='isGlobal && editedExtension.usage.length > 1')
          span {{ $t('This extension is Global and cannot be changed into Local, beacause it\'s in use by many networks.') }}
        el-form-item
          el-button(id="EditExtension-save" type='success', @click='saveExtension()')
            span {{ $t('Save Extension')}}
  </template>

<script>
import Vue from 'vue'
import testUtils from './../Common/textUtils.mixin'

export default {
  mixins: [testUtils],
  props: ['side', 'folder'],
  async created () {
    await this.loadData()
  },
  data () {
    return {
      loading: false,
      exisitingUsedExtensions: [],
      editedExtension: undefined,
      isGlobal: false,
      editExtensionVisible: false
    }
  },
  methods: {
    async loadData () {
      this.loading = true
      this.exisitingUsedExtensions = (await Vue.axios.get(`extension/findUsed`)).data
      this.loading = false
    },
    async closeEditExtension () {
      this.editedExtension = undefined
      this.isGlobal = false
      this.editExtensionVisible = false
      await this.loadData()
    },
    async saveExtension () {
      if (this.isGlobal) {
        this.editedExtension.Network = null
        this.editedExtension.isGlobal = this.isGlobal
      } else {
        this.editedExtension.Network = this.editedExtension.usage[0].id
      }
      delete this.editedExtension.usage
      delete this.editedExtension.networkName
      console.log(this.editedExtension)
      await Vue.axios.patch(`extension/updateExtension`, this.editedExtension)
    },
    editExtension (extension) {
      this.editExtensionVisible = true
      this.editedExtension = extension
      this.isGlobal = !this.editedExtension.Network
    },
    async handleSelectNetwork (newNetwork) {
      if (!this.$store.state.User.user.Networks.find(network => network.id === newNetwork.id)) {
        await this.$store.dispatch('User/addNetworkToAdminNetworks', newNetwork)
      }
      this.$emit('changeNetwork', newNetwork.id)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.form-container {
  display: flex;
  justify-content: center;
}
.delete-button-row {
  border: 0px dotted pink;
  text-align: right;
  margin: 30px 0px -20px 0px;
  width: 1205px;
}
.error {
  color: $--color-warning;
}
.existing-extension-section {
  display: flex;
  align-items: center;
  flex-direction: column;
  .advice {
    color: $--color-text-secondary;
  }
  .existing-extension-row {
    display: flex;
    min-height: 30px;
    align-items: center;
    border-bottom: $--border-light;
    &.isSelected {
      background-color: $--background-color-selected;
    }
    .cell {
      font-size: $--font-size-base;
      padding: 10px;
      &.header {
        color: $--color-text-secondary;
      }
      &.name {
        width: 160px;
      }
      &.description {
        width: 750px;
      }
      &.version {
        width: 50px;
      }
      &.global {
        width: 150px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/ExtensionsUsageReport.vue